<template>
    <tr
        class="animated fadeIn kgr-table__row"
        :class="{'is-deleted': value.deleted, 'kgr-table__row--highlight': value.isActive()}"
    >
        <td class="kgr-table__cell">
            <kgr-membership-number
                v-if="!isGuestContract(value.type)"
                v-model="value.membershipNumber"
                :club-id="clubId"
                :member-id="memberId"
                :is-editable="editing"
                :error="error"
            />
            <span v-else>-</span>
        </td>
        <td class="kgr-table__cell">
            {{ $t('memberContract.type.' + value.type) }}
        </td>
        <td class="kgr-table__cell">
            <kgr-form-row
                :error="error"
                field-name="start"
                required
            >
                <kgr-date-picker
                    :value="value.start"
                    :display-only="!editing"
                    @post-input="inputStart"
                    @error="invalidStart"
                    @enter="onKeyUpEnter"
                />
            </kgr-form-row>
        </td>
        <td class="kgr-table__cell">
            <kgr-form-row
                :error="error"
                field-name="end"
            >
                <kgr-date-picker
                    v-model.trim="value.end"
                    :value="value.end"
                    :display-only="!editing"
                    @post-input="inputEnd"
                    @error="invalidEnd"
                    @enter="onKeyUpEnter"
                />
            </kgr-form-row>
        </td>
        <td class="kgr-table__cell">
            <kgr-form-row
                :error="error"
                field-name="terminationReason"
            >
                <kgr-termination-reason-select
                    v-if="editing"
                    v-model="value.terminationReason"
                    :club-id="clubId"
                />
                <template v-else>
                    {{ value.terminationReason ? value.terminationReason.value : '' }}
                </template>
            </kgr-form-row>
        </td>
        <td
            v-if="isEditable"
            class="kgr-table__cell kgr-table__cell--actions"
        >
            <kgr-icon-edit
                v-if="!value.isNew() && isEditable"
                :disabled="editing"
                :size="15"
                class="kgr-table__action"
                @click="toggleEdit()"
            />
            <kgr-icon-delete
                v-if="isEditable && !value.deleted"
                class="kgr-table__action"
                @click="markDeleted(true)"
            />
            <kgr-icon-reset
                v-if="value.deleted"
                class="kgr-table__action"
                @click="markDeleted(false)"
            />
        </td>
    </tr>
</template>

<script>
import DatePicker from '../common/form/picker/DateObjectPicker';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import IconDelete from '../common/icon/IconDelete';
import IconEdit from '../common/icon/IconEdit';
import IconReset from '../common/icon/IconReset';
import MemberGuestContract from '../../js/dto/MemberGuestContract';
import MemberPassiveContract from '../../js/dto/MemberPassiveContract';
import MemberRegularContract from '../../js/dto/MemberRegularContract';
import MembershipNumber from './membership-number/MembershipNumber';
import TerminationReasonSelect from './TerminationReasonSelect';

export default {
    components: {
        'kgr-termination-reason-select': TerminationReasonSelect,
        'kgr-form-row': FormRow,
        'kgr-date-picker': DatePicker,
        'kgr-membership-number': MembershipNumber,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-icon-reset': IconReset,
    },
    props: {
        value: {
            type: [MemberRegularContract, MemberGuestContract, MemberPassiveContract],
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            editMode: false,
            deleted: false,
        }
    },
    computed: {
        editing() {
            return this.editMode || this.value.isNew();
        },
    },
    methods: {
        inputStart(value) {
            const index = this.value.invalidChanges.indexOf('start');
            if (index > -1) {
                this.value.invalidChanges.splice(index, 1);
            }
            this.value.start = value
        },
        invalidStart() {
            if(this.value.invalidChanges.indexOf('start') === -1) {
                this.value.invalidChanges.push('start');
            }
        },
        inputEnd(value) {
            const index = this.value.invalidChanges.indexOf('end');
            if (index > -1) {
                this.value.invalidChanges.splice(index, 1);
            }
            this.value.end = value
        },
        invalidEnd() {
            if(this.value.invalidChanges.indexOf('end') === -1) {
                this.value.invalidChanges.push('end');
            }
        },
        isGuestContract() {
            return this.value instanceof MemberGuestContract;
        },
        onKeyUpEnter() {
            this.$emit('enter');
        },
        toggleEdit() {
            this.editMode = !this.editMode;
        },
        markDeleted(deleted) {
            this.editMode = false;
            this.value.deleted = deleted;
            this.$emit(deleted ? 'delete' : 'undelete', this.value)
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .min-height {
        min-height: 100px;
    }
</style>
